import { Pipe, PipeTransform } from '@angular/core';



const resultLookup = {
  1: 'Transfer',
  2: 'Routing Rule',
  3: 'Queue Timeout',
  4: 'Nightmode',
  5: 'Overflow',
  6: 'ACD Fallback'
};


@Pipe({
  name: 'telepoCdrDiversionReason'
})
export class TelepoCdrDiversionReason implements PipeTransform {
  transform(value: string): any {
    if (value != null) return resultLookup[value] ?? "Unknown Diversion Reason - " + value;
    return '';
  }
}
